import React from 'react';
import { Editor } from '@tiptap/react';
import { ButtonMainDiv, Divider, TableMainDiv } from '../styles';
import IconButton from '../../button/iconButton';
import { ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../../global/constants';

interface TableToolbarProps {
  editor: Editor;
}

const TableToolbar: React.FC<TableToolbarProps> = ({ editor }) => {
  if (!editor) return null;

  const handleClick = (callback: () => void) => (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    callback();
  };

  return (
    <TableMainDiv role='button' onClick={(e) => e.stopPropagation()}>
      <ButtonMainDiv>
        <p>Rows</p>
        <IconButton
          iconName='plus-icon'
          size={ICON_BUTTON_SIZE.MEDIUM}
          variant={ICON_BUTTON_TYPE.TERTIARY}
          onClick={handleClick(() => editor.chain().focus().addRowAfter().run())}
        />
        <IconButton
          iconName='updated-minus-icon'
          size={ICON_BUTTON_SIZE.MEDIUM}
          variant={ICON_BUTTON_TYPE.TERTIARY}
          onClick={handleClick(() => editor.chain().focus().deleteRow().run())}
        />
      </ButtonMainDiv>
      <Divider />
      <ButtonMainDiv>
        <p>Columns</p>
        <IconButton
          iconName='plus-icon'
          size={ICON_BUTTON_SIZE.MEDIUM}
          variant={ICON_BUTTON_TYPE.TERTIARY}
          onClick={handleClick(() => editor.chain().focus().addColumnAfter().run())}
        />
        <IconButton
          iconName='updated-minus-icon'
          size={ICON_BUTTON_SIZE.MEDIUM}
          variant={ICON_BUTTON_TYPE.TERTIARY}
          onClick={handleClick(() => editor.chain().focus().deleteColumn().run())}
        />
      </ButtonMainDiv>
      <Divider />
      <ButtonMainDiv className='header'>
        <p>Header</p>
        <IconButton
          iconName='table-first-row-header-icon'
          size={ICON_BUTTON_SIZE.MEDIUM}
          variant={ICON_BUTTON_TYPE.TERTIARY}
          onClick={handleClick(() => editor.chain().focus().toggleHeaderRow().run())}
        />
        <IconButton
          iconName='table-first-column-header-icon'
          size={ICON_BUTTON_SIZE.MEDIUM}
          variant={ICON_BUTTON_TYPE.TERTIARY}
          onClick={handleClick(() => editor.chain().focus().toggleHeaderColumn().run())}
        />
      </ButtonMainDiv>
      <Divider />
      <IconButton
        iconName='updated-delete-icon'
        size={ICON_BUTTON_SIZE.MEDIUM}
        variant={ICON_BUTTON_TYPE.TERTIARY}
        onClick={handleClick(() => editor.chain().focus().deleteTable().run())}
      />
    </TableMainDiv>
  );
};

export default TableToolbar;
